export default {
    created() {
        
    },
    methods: {
    },
    computed: {
        pageComp () {
            return `Page${this.$TestApp.getPageCurrent()}`
        }
    }
}